import classnames from "classnames";
import {PropsWithChildren, ReactNode} from "react";
import {Offcanvas, OffcanvasProps} from "react-bootstrap";
import {IconType} from "react-icons";

import {Icon} from "@/components/icon/Icon.tsx";

import {DrawerModalFooter} from "./FormDrawerFooter.tsx";

import css from "./FormDrawer.module.css";

interface FormDrawerProps extends PropsWithChildren, OffcanvasProps {
  submitBtnText?: string;
  cancelBtnText?: string;
  title: ReactNode;
  titleIcon?: IconType;
  formId?: string;
  disabled?: boolean;
  onCancel?: () => void;
  onSubmit?: () => void;
  hasSubmitButton?: boolean;
  hasCancelButton?: boolean;
  isSecondaryLevel?: boolean; // Set to true if used in multiple levels of drawers
  extraButtons?: ReactNode;
  size?: "sm" | "md" | "lg";
}

export const FormDrawer = ({
  title,
  titleIcon,
  formId,
  onCancel,
  disabled,
  submitBtnText,
  cancelBtnText,
  onSubmit,
  hasSubmitButton = true,
  hasCancelButton = true,
  isSecondaryLevel = false,
  extraButtons,
  size = "sm",
  children,
  ...rest
}: FormDrawerProps) => {
  const {className} = rest;
  return (
    <Offcanvas onHide={onCancel} {...rest} className={classnames(className, css[size])}>
      <Offcanvas.Header closeButton>
        <Offcanvas.Title>
          {titleIcon && <Icon display={"inline"} size={"kpi"} icon={titleIcon} />}
          {title}
        </Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body>{children}</Offcanvas.Body>
      {hasSubmitButton || hasCancelButton ? (
        <DrawerModalFooter
          onCancel={onCancel}
          disabled={disabled}
          formId={formId}
          hasSubmitButton={hasSubmitButton}
          hasCancelButton={hasCancelButton}
          submitText={submitBtnText}
          cancelText={cancelBtnText}
          onSubmit={onSubmit}
          isSecondaryLevel={isSecondaryLevel}
          extraButtons={extraButtons}
        />
      ) : (
        <></>
      )}
    </Offcanvas>
  );
};
